import {Modal} from 'react-bootstrap'
import {CircularProgress} from '@mui/material';

const ModalLoading = ({show}) => {
    return (
        <>
            <Modal show={show} centered >
                <Modal.Body>
                    <div style={{ textAlign: 'center', margin: '20px' }}>
                    <p style={{ marginBottom: '30px'}} >
                        Please, wait for task to done.
                    </p>
                    <CircularProgress />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ModalLoading;
